/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row } from "../../../styles/TableStyles";
import { getConfigColumnStyle, cellProps } from "../../../utils/tableUtils";
import { CellFilter } from "./CellFilter";

interface TableRowProps {
  row: any;
  rowIndex: number;
  prepareRow: (row: any) => void;
  isShowDecoratorColor: boolean;
  showConfigColumn: boolean;
  onRenderConfig?: (original: any) => React.ReactNode;
  isGroupedMode: boolean;
  // Filter props
  isDisabbledAddFilter?: boolean;
  restrictedFilters?: string[];
  filterVisibleKeys?: string[];
  filterMap?: Record<string, unknown>;
  onFilterClicked?: (
    action: string,
    columnKey: string,
    filterKeys: string[],
    cellValue: any[] | null
  ) => void;
  // Simplified mode for DynamicTable (no filters)
  simplified?: boolean;
}

export const TableRow = ({
  row,
  rowIndex,
  prepareRow,
  isShowDecoratorColor,
  showConfigColumn,
  onRenderConfig,
  isGroupedMode,
  isDisabbledAddFilter = true,
  restrictedFilters,
  filterVisibleKeys,
  filterMap,
  onFilterClicked,
  simplified = false,
}: TableRowProps) => {
  prepareRow(row);

  let decoratorColor = "";
  if (isShowDecoratorColor) {
    decoratorColor =
      row.original && row.original.decoratorColor
        ? row.original.decoratorColor
        : null;
  }

  const { key: rowKey, ...rowProps } = row.getRowProps();

  return (
    <Row
      key={rowKey ?? rowIndex}
      {...rowProps}
      className={`tr ${rowIndex % 2 ? "even" : "odd"}`}
      $decoratorColor={decoratorColor}
      $isShowDecoratorColor={isShowDecoratorColor}
    >
      {showConfigColumn && (
        <div style={getConfigColumnStyle()} className="td">
          <div>
            {!isGroupedMode && onRenderConfig && onRenderConfig(row.original)}
          </div>
        </div>
      )}
      {row.cells.map((cell: any, index: number) => {
        const { key: cellKey, ...cellPropsRest } = cell.getCellProps(cellProps);
        return (
          <div key={cellKey ?? index} {...cellPropsRest} className="td">
            {simplified ? (
              <div className={`${cell.column.cellClass || ""}`}>
                {cell.render("Cell")}
              </div>
            ) : (
              <CellFilter
                cell={cell}
                row={row}
                isDisabbledAddFilter={isDisabbledAddFilter}
                restrictedFilters={restrictedFilters}
                filterVisibleKeys={filterVisibleKeys}
                filterMap={filterMap}
                onFilterClicked={onFilterClicked}
                className={cell.column.cellClass || ""}
              >
                {cell.render("Cell")}
              </CellFilter>
            )}
          </div>
        );
      })}
    </Row>
  );
};
